export default __webpack_public_path__ + "static/scrollable-overlay-ec2fe0c96c1eba708d6732d9e8736b57.png";